import React, {useCallback, useEffect} from 'react';
import {Box, Typography} from 'web-library';
import {useTranslation} from 'react-i18next';
import {useHistory, useLocation} from 'react-router-dom';
import {useQueryClient} from 'react-query';
import {useAuth} from '../logic/auth';
import {usePostMIMSCallback} from '../../../api-refactored/user/usePostMIMSCallback';
import {useTriggerMutate} from '../../../hooks/query';
import {GET_USER_DETAILS_QUERY_KEY} from '../../../constants/queryKeys';
import {LocationState} from '../../../models/Location';
import RouteKey from '../../../routes/key';
import {CUSTOMIZED_UNAUTHORIZED_STATUS_CODE} from '../../../api/config/misc';

const {auth: authKey} = RouteKey.child;
const {login} = RouteKey.auth.child;

const url = window.location.search;
const params = new URLSearchParams(url);
const mimsRequest = {code: params.get('code') || '', state: params.get('state') || ''};

const MIMS = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const location = useLocation<LocationState>();
  const auth = useAuth();
  const queryClient = useQueryClient();

  const urlToBeRedirectedAfterLoggedInData = sessionStorage.getItem(
      'urlToBeRedirectedAfterLoggedIn'
  ) as string;
  const urlToBeRedirectedAfterLoggedInObject = JSON.parse(urlToBeRedirectedAfterLoggedInData);

  const {mutate: postMIMSCallback} = usePostMIMSCallback({
    onSuccess: () => {
      queryClient.invalidateQueries(GET_USER_DETAILS_QUERY_KEY);
      auth.signin();
      history.replace(
          `${urlToBeRedirectedAfterLoggedInObject.from.pathname}${urlToBeRedirectedAfterLoggedInObject.from.search}`,
          {
            from: {pathname: location.pathname},
          }
      );
      sessionStorage.removeItem('urlToBeRedirectedAfterLoggedIn');
    },
    onError: (err) => {
      const data = err.response?.data;
      const code = data?.code;

      switch (err.response?.status) {
        case CUSTOMIZED_UNAUTHORIZED_STATUS_CODE:
          if (code === '1008' || code === '1006' || code === '1009' || code === '4008') {
            history.push(`/${authKey}/${login}`, {
              message: data!.message,
              code,
            });
          }
          break;
        case 403:
          if (code === '1007') {
            history.push('/error/403');
          }
          break;
        case 417:
          if (code === '1201' && data?.data!.url !== undefined) {
            window.location.href = data?.data.url as string;
          }
          break;
        default:
          history.push('/');
          break;
      }
    },
  });

  const callMutation = useCallback(() => {
    postMIMSCallback(mimsRequest);
  }, [postMIMSCallback]);
  const setTriggerMutate = useTriggerMutate(callMutation);

  useEffect(() => {
    if (mimsRequest.code && mimsRequest.state) {
      setTriggerMutate((prev) => prev + 1);
    }
  }, [setTriggerMutate]);

  return (
      <Box>
        <br/>
        <Typography variant="h6">&nbsp;&nbsp;{t('profile->>MIMS.Login')}</Typography>
      </Box>
  );
};

export default MIMS;
